import React from 'react';
import { ProgressBar, Step } from 'react-step-progress-bar';

const MultiStepProgressBar = ({ page, stepsLabels, steps }) => {
  const renderSteps = Array(steps).fill().map((_, i) => i);

  const changePercentaje = () => {
    const porcentTable = {
      2: {
        1: 49.5,
        2: 100,
      },
      3: {
        1: 16,
        2: 65,
        3: 100,
      },
      4: {
        1: 16,
        2: 49,
        3: 82,
        4: 100,
      },
    };

    // eslint-disable-next-line no-nested-ternary
    return porcentTable[steps] ? porcentTable[steps][page] ? porcentTable[steps][page] : porcentTable[steps][1] : 0;
  };

  const styledLabels = (label) => {
    if (label.includes('Forma')) {
      return {
        width: '160px',
        textAlign: 'center',
        left: '-60%',
      };
    } else if (label.includes('Verificación de retiro') || label.includes('Verificación de cierre')) {
      return {
        width: '160px',
        textAlign: 'center',
        left: '-190%',
      };
    }
    return {
      width: '160px',
      textAlign: 'center',
      left: '-430%',
    };
  };

  return (
    <React.Fragment>
      <ProgressBar percent={changePercentaje()}>
        {
          renderSteps.map(index => (
            <Step key={index}>
              {({ accomplished }) => (
                <React.Fragment>
                  <div className={`indexedStep ${accomplished ? 'completed' : ''}`}>
                    {accomplished == true && page != index + 1
                    ? <i className="icon-check" style={{ color: '#ffffff' }} />
                    : index + 1}
                  </div>
                  <div
                    style={styledLabels(stepsLabels[index])}
                    className={`labelAlignWeb${page} textStep0 ${accomplished ? 'textCompleted' : ''}`}
                  >
                    { page != index + 1 ? stepsLabels[index] : null
                    }
                  </div>
                </React.Fragment>
              )}
            </Step>
          ))
        }
      </ProgressBar>
    </React.Fragment>
  );
};

export default MultiStepProgressBar;
